/**
 * Appends an Intro.js step when `element` is present.
 * Pass `null` or `undefined` to skip (missing DOM node or conditional step such as Simple UI).
 * @param {Array<{ element: Element, intro: string, position: string }>} steps
 * @param {Element | null | undefined} element
 * @param {{ intro: string, position: string }} config
 */
export function pushTourStepIf(steps, element, { intro, position }) {
  if (element) {
    steps.push({ element, intro, position });
  }
}
